<template>

<com-item name="game.plays.duration" :size="size" :is-empty="!active" :loading="loading" title="Duration">

	<template v-slot:about>

		<p>How long were {{ your }} plays of this game in minutes.</p>

	</template>

	<template v-slot:stats>

		<core-widget :is-slim="true" v-if="active">

			<div class="durations-list">

				<div class="durations-list-shading">
					<div class="durations-list-shading-item" v-for="(label, index) in shadingLabels" :key="'s' + index">{{ label }}</div>
				</div>

				<div class="durations-list-item" v-tooltip="tooltip(index)" v-for="(value, index) in bars" :key="index">
					<div :style="height(value)"></div>
				</div>

			</div>

		</core-widget>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			var plays = this.$store.getters['page/insights/game/plays']
			return (plays && plays.duration) ? plays.duration : {}

		},

		active: function() {

			return this.$_.keys(this.data).length && !this.loading

		},

		bucketCount: function() {

			var keys = this.$_.keys(this.data)
			if (!keys.length) return 18
			var max = this.$_.max(keys, function(k) { return parseInt(k) })
			return Math.max(18, parseInt(max))

		},

		hourCount: function() {

			return Math.ceil(this.bucketCount / 6)

		},

		shadingLabels: function() {

			var labels = []
			for (var i = 0; i < this.hourCount; i++) {
				labels.push(i + '-' + (i + 1) + 'hr')
			}
			return labels

		},

		bars: function() {

			var result = []
			for (var i = 1; i <= this.bucketCount; i++) {
				result.push(this.data[i] || 0)
			}
			return result

		},

		max: function() {

			return this.$_.max(this.bars) || 1

		}

	},

	methods: {

		tooltip: function(index) {

			var from = index * 10
			var to = from + 10
			var value = this.bars[index]
			return from + ' - ' + to + ' minutes<small>' + value + ' play' + (value === 1 ? '' : 's') + '</small>'

		},

		height: function(value) {

			return {
				height: ((100 / this.max) * value) + '%'
			}

		}

	}

}

</script>

<style scoped>

.durations-list {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
}

.durations-list-shading {
	z-index: 1;
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	display: flex;
}

.durations-list-shading-item {
	height: 100%;
	font-size: 16px;
	font-weight: 700;
	text-align: center;
	color: #a0c3cf;
	padding: 5px;
	flex: 1;
}

.durations-list-shading-item:nth-child(even) {
	background-color: rgba(12, 137, 178, 0.05);
}

.durations-list-item {
	height: 100%;
	padding: 25px 0px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 2;
	flex: 1;
}

.durations-list-item:hover {
	background-color: rgba(12, 137, 178, 0.1);
}

.durations-list-item div {
	width: 50%;
	border-radius: 4px;
	min-height: 2px;
	background-color: #4881bb;
	transition: height 100ms linear;
}

</style>
